import { MediaQueryWrapper, TranslationsContext } from '@telia-common-components/shared';
import { observer } from 'mobx-react';
import React from 'react';
import { LargeSearch, Skeleton, SkeletonItem, SuggestionField, useAnalytics, useCurrentBreakPoint, useTheme } from 'telia-front-react';
const AddressAutocompleteContent = (props) => {
    var _a, _b, _c;
    const { translate } = React.useContext(TranslationsContext);
    const { push } = useAnalytics();
    const { media } = useTheme();
    const currentBreak = useCurrentBreakPoint();
    const isMobile = currentBreak === 'xs' || currentBreak === 'sm';
    const { labelsPrefix, addressAutocompleteStore, roomLabel, autoSubmit, isLoading } = props;
    const labelPrefix = labelsPrefix ? `${labelsPrefix}.` : '';
    const onAddressSelect = async (item) => {
        await addressAutocompleteStore.onAddressAutocompleteSelectAddress(item);
        autoSubmit && doSubmit(null);
    };
    const onApartmentSelect = () => {
        autoSubmit && doSubmit(null);
    };
    const doSubmit = (event) => {
        if (event) {
            event.preventDefault();
        }
        else if (!addressAutocompleteStore.isValidApartment()) {
            return;
        }
        addressAutocompleteStore.handleApartmentNotice();
        if (props.onSubmit && !addressAutocompleteStore.isApartmentInvalid) {
            if (addressAutocompleteStore.selectedAddress) {
                props.onSubmit(addressAutocompleteStore.selectedAddress, addressAutocompleteStore.findRoom(), isMobile);
            }
            else {
                addressAutocompleteStore.error = 'selectFromSuggestions';
            }
        }
        setTimeout(() => { var _a; return (_a = document.getElementById('addressAutocomplete-search')) === null || _a === void 0 ? void 0 : _a.focus(); }, 100);
        if (addressAutocompleteStore.error) {
            push(`Address field error - ${addressAutocompleteStore.error}`);
        }
    };
    if (isLoading) {
        return (React.createElement(Skeleton, { label: translate('skeleton.loading'), className: "text-center" },
            React.createElement(MediaQueryWrapper, { minWidth: media.width.md.min, matchingContent: React.createElement(SkeletonItem, { height: "64px", width: "55%" }), unmatchingContent: React.createElement(SkeletonItem, { height: "128px", width: "90%" }) })));
    }
    const formClass = isMobile ? 'large-search--multiline-conditional' : '';
    return (React.createElement("div", null,
        React.createElement(LargeSearch, { id: "addressAutocomplete-search", align: "center", className: ((_a = addressAutocompleteStore.roomSuggestions) === null || _a === void 0 ? void 0 : _a.length) ? `is-dirty ${formClass}` : `${formClass}`, onSubmit: doSubmit, multiline: isMobile, helper: !!addressAutocompleteStore.error
                ? {
                    type: 'error',
                    text: translate(`addressAutocomplete.error.${addressAutocompleteStore.error}`)
                }
                : null, submitButton: {
                text: translate(`${labelPrefix}addressAutocomplete.submitText`),
                iconRight: '#search'
            }, formAttributes: { tabIndex: -1 } },
            React.createElement(SuggestionField, { id: "addressAutocomplete-address-field", value: addressAutocompleteStore.addressText, label: translate(`${labelPrefix}addressAutocomplete.address${isMobile ? '.shorterForMobile' : ''}`), items: addressAutocompleteStore.suggestions, onChange: addressAutocompleteStore.onAddressAutocompleteChange, onSelect: onAddressSelect, isClearable: true, onClear: addressAutocompleteStore.clearAddress, isLoading: !((_b = addressAutocompleteStore.suggestions) === null || _b === void 0 ? void 0 : _b.length) && addressAutocompleteStore.isFetchingResults }),
            ((_c = addressAutocompleteStore.roomSuggestions) === null || _c === void 0 ? void 0 : _c.length) ? (React.createElement(SuggestionField, { id: "addressAutocomplete-apartment-field", value: addressAutocompleteStore.roomText, label: translate(roomLabel ? roomLabel : `${labelPrefix}addressAutocomplete.room`), items: addressAutocompleteStore.roomSuggestions, onChange: addressAutocompleteStore.onRoomAutocompleteChange, onFocus: addressAutocompleteStore.onAddressAutocompleteRoomFocus, onBlur: addressAutocompleteStore.onAddressAutocompleteRoomBlur, onSelect: onApartmentSelect, showSuggestionsOnFocus: true })) : null)));
};
export default observer(AddressAutocompleteContent);
